var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-lg-8" }, [
      _c("div", { staticClass: "dashboard-block" }, [
        _c("ul", { staticClass: "paymentPageActions" }, [
          _c("li", [
            _c(
              "button",
              {
                staticClass: "paymentPageActions_item",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    _vm.editingBilling = true
                  },
                },
              },
              [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "paymentPageActions_name" }, [
                  _vm._v("Edit Billing Info"),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _vm.$paymentsModuleEnabled
            ? _c("li", [
                _c(
                  "a",
                  {
                    staticClass: "paymentPageActions_item",
                    attrs: { href: _vm.bookingTncLink(), target: "_blank" },
                    on: { click: _vm.trackPaymentTermsClick },
                  },
                  [
                    _vm._m(1),
                    _vm._v(" "),
                    _c("div", { staticClass: "paymentPageActions_name" }, [
                      _vm._v("Payment Terms"),
                    ]),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.$paymentsModuleEnabled
            ? _c("li", [
                _c(
                  "a",
                  {
                    staticClass: "paymentPageActions_item",
                    attrs: {
                      href: "https://intercom.help/pickstar-help/en/collections/2830220-client#payment",
                      target: "_blank",
                    },
                    on: { click: _vm.trackPaymentFaqClick },
                  },
                  [
                    _vm._m(2),
                    _vm._v(" "),
                    _c("div", { staticClass: "paymentPageActions_name" }, [
                      _vm._v("Payment FAQs"),
                    ]),
                  ]
                ),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _vm.editingBilling
        ? _c(
            "div",
            { staticClass: "dashboard-block" },
            [
              _c("edit-billing-info-form", {
                attrs: { user: _vm.booking.client },
                on: {
                  close: function ($event) {
                    _vm.editingBilling = false
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.upcomingPayments.length && _vm.$paymentsModuleEnabled
        ? _c("div", { staticClass: "dashboard-block" }, [
            _c("h2", [_vm._v("Upcoming")]),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "item-detail item-detail-payment" },
              _vm._l(_vm.upcomingPayments, function (payment) {
                return _c("booking-single-payment-list-item", {
                  key: payment.id,
                  attrs: { payment: payment },
                })
              }),
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "dashboard-block" }, [
        _c("h2", [
          _vm._v(
            _vm._s(_vm.$paymentsModuleEnabled ? "Payment History" : "Invoices")
          ),
        ]),
        _vm._v(" "),
        _c("ul", { staticClass: "item-detail item-detail-payment" }, [
          _c(
            "li",
            [_c("invoice-item", { attrs: { booking: _vm.booking } })],
            1
          ),
          _vm._v(" "),
          _vm.transactions.length && _vm.$paymentsModuleEnabled
            ? _c(
                "li",
                [
                  _c("transaction-history", {
                    attrs: { transactions: _vm.transactions },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-lg-4" }, [
      _c(
        "div",
        { staticClass: "dashboard-block" },
        [
          _vm.helpSteps.length
            ? _c("help-steps", { attrs: { steps: _vm.helpSteps } })
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "paymentPageActions_icon" }, [
      _c("i", { staticClass: "fa fa-edit" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "paymentPageActions_icon" }, [
      _c("i", { staticClass: "fa fa-file-alt" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "paymentPageActions_icon" }, [
      _c("i", { staticClass: "fa fa-book" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }